import React, { useEffect, useState } from "react";
import axios from "axios";
import logo from "../../Assets/Images/logo.png";
import "./Navbar.scss";
import { toast } from "react-toastify";
import {navigate} from "@storybook/addon-links";
import {useNavigate} from "react-router-dom";

export default function Navbar({ setIsAuth }) {
  // const [theme, setTheme] = useState(
  //   localStorage.getItem("theme") === null
  //     ? "light"
  //     : localStorage.getItem("theme")
  // );

  // function changeThemeOnChangeHandler(e) {
  //   e.target.checked ? setTheme("dark") : setTheme("light");
  // }
  const navigateTo = useNavigate();
  function logOutHandler() {
    let HOST = window.location.hostname==="localhost"?"http://localhost/Git/Delsa/Frm" : "/Frm"
    const logOutRequest = axios({
      method: "post",
      url: `${HOST}/check_user/`,
      params: { logout: "logout" },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => {
      localStorage.removeItem("token");
      sessionStorage.setItem("isAuth", false);
      setIsAuth(false);
    }).catch((error) => {
      localStorage.removeItem("token");
      sessionStorage.setItem("isAuth", false);
      setIsAuth(false);
      navigateTo("/Login");
    });

    toast.promise(logOutRequest, {
      pending: "در حال خروج از حساب",
      success: "خروج با موفقیت ثبت شد",
      error: "ثبت خروج با مشکل مواجه شد",
    });

    console.log("logOutRequest");
  }

  // useEffect(() => {
  //   localStorage.setItem("theme", theme);
  //   document.documentElement.dataset.theme = theme;
  // }, [theme]);

  return (
    <nav className="navbar">
      <div className="logo-container">
        <img src={logo} alt="logo" />
      </div>

      {/* <!-- Links --> */}
      <ul className="navbar-nav">
        {/* <li className="nav-item">
         
          <div className="form-check form-switch">
            <input
              type="checkbox"
              className="form-check-input"
              id="customSwitches"
              onChange={(e) => {
                changeThemeOnChangeHandler(e);
              }}
              checked={theme === "dark" ? true : false}
            />
           
            <i className="fas fa-moon"></i>
           
          </div>
        </li> */}
        <li className="nav-item">
          <div className="nav-link" onClick={logOutHandler}>
            <i className="fas fa-power-off"></i>
          </div>
        </li>
      </ul>
    </nav>
  );
}
